import { createSelector } from '@ngrx/store';

import * as fromInterventions from '../intervention/intervention.reducer';
import { selectDashboardState } from '../dashboard.selectors';

export const selectInterventionState = createSelector(selectDashboardState, (dashboard) => dashboard?.intervention);

export const selectIsLoadingInterventions = createSelector(
  selectInterventionState,
  (interventionState) => interventionState?.loadingInterventions
);

export const selectInterventionsLoaded = createSelector(
  selectInterventionState,
  (interventionState) => interventionState?.interventionsLoaded
);

export const selectIsLoadingIntervention = createSelector(
  selectInterventionState,
  (interventionState) => interventionState?.loadingIntervention
);

export const selectInterventionLoaded = createSelector(
  selectInterventionState,
  (interventionState) => interventionState?.interventionLoaded
);

export const selectInterventions = createSelector(selectInterventionState, fromInterventions.selectAll);

export const selectSelectedIntervention = createSelector(
  selectInterventionState,
  (interventionState) => interventionState?.selectedIntervention
);

export const selectStartModuleSet = createSelector(
  selectInterventionState,
  (interventionState) => interventionState?.startModuleSet
);
